import React from 'react';
import classNames from 'classnames';

interface SVGTitle {
  title?: string;
}

export interface IRCIconProps {
  /* accessible title attribute; required for non-decorative icons, should be left blank if the icon is purely decorative and a screen reader
  can get the context from other elements */
  title?: string;
  /* Set to false (default) to allow the icon to take up the full width of the parent container
    Set to true to use the icon inline with text. The parent container's font size will control the size. */
  inline?: boolean;
  nativeSize?: boolean;
  svgComponent: (props: (React.SVGProps<SVGElement> & SVGTitle)) => React.ReactSVGElement; // a specific svg imported from commons/design-system/icons
}

export default function RCIcon({
  inline = false,
  nativeSize = false,
  title,
  svgComponent,
}: IRCIconProps) {
  const WrappedSVGComponent = svgComponent;

  const classes = classNames('rc-icon', {
    'rc-icon--inline': inline,
    'rc-icon--native-size': nativeSize,
  });

  // if there is no accessible title, then the icon is decorative and should be
  // hidden from screen readers
  const ariaHidden = !title ? true : undefined;

  return (
    <span className={classes}>
      <WrappedSVGComponent title={title} aria-hidden={ariaHidden} />
    </span>
  );
}
